import { RewardsCriteria } from '@/entities';

import { RootState } from '../store';


export const selectSeasonInfoData = (state: RootState) => state.seasonInfo.data;
export const selectSeasonInfoRewardsCriteria: (state: RootState) => RewardsCriteria = (
  state: RootState
) =>
  state.seasonInfo.data?.rewards_criteria || {
    wallet: false,
    tasks: false,
    onchain_activity: false,
    balance: false
  };
export const selectSeasonInfoLoading = (state: RootState) => state.seasonInfo.loading;
export const selectSeasonInfoError = (state: RootState) => state.seasonInfo.error;
